module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1007-88f4450462efae449fbb75fc39ae9384.png";